/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';

export const ColStyled = styled(Col)`
  display: flex;
  justify-content: center;
`;
